var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state.embedDemo === true)?_c('app-embed',{staticClass:"app"}):(_vm.state.room == 'welcome')?_c('app-welcome',{staticClass:"app"}):(_vm.state.room == null || _vm.state.room == undefined)?_c('app-startpage',{staticClass:"app"}):_c('app-main')
}
var staticRenderFns = []

export { render, staticRenderFns }